import {  get_new_id } from "./functions";


// -------------------------   
const AgencyName ="CodeSperix";
     
// -------------------------        

// -------------------------
// -------------------------
const initial_service_details=[
    {
      title:"React JS",
      url:"/#servcies_section",
      service_details:"Lorem ipsum dolor sit amet.Lorem ipsum dolor sit amet consectetur, adipisicing elit. Perferendis, unde.Lorem ipsum dolor sit amet.Lorem ipsum dolor sit amet consectetur, adipisicing elit. Perferendis, unde.123",
      icon:"fab fa-react"

    },
    {
      title:"Web development",
      url:"/#servcies_section",
      service_details:"Lorem ipsum dolor sit amet.Lorem ipsum dolor sit amet consectetur, adipisicing elit. Perferendis, unde.",
      icon:"fas fa-laptop-code"

    },
    {
      title:"React JS",
      url:"/#servcies_section",
      service_details:"Lorem ipsum dolor sit amet.Lorem ipsum dolor sit amet consectetur, adipisicing elit. Perferendis, unde.",
      icon:"fab fa-react"

    },
    {
      title:"Web development",
      url:"/#servcies_section",
      service_details:"Lorem ipsum dolor sit amet.Lorem ipsum dolor sit amet consectetur, adipisicing elit. Perferendis, unde.",
      icon:"fas fa-laptop-code"

    },
    {
      title:"React JS",
      url:"/#servcies_section",
      service_details:"Lorem ipsum dolor sit amet.Lorem ipsum dolor sit amet consectetur, adipisicing elit. Perferendis, unde.",
      icon:"fab fa-react"

    },
    {
      title:"Web development",
      url:"/#servcies_section",
      service_details:"Lorem ipsum dolor sit amet.Lorem ipsum dolor sit amet consectetur, adipisicing elit. Perferendis, unde.",
      icon:"fas fa-laptop-code"

    },
]
// -------------------------
// -------------------------

// -------------------------
// -------------------------

// -------------------------
// -------------------------
const agency_name="CodePhoenix";

// -------------------------


// --------------------------

// --------------------------
const whatsappNumber ="+92 326-4331067";
const whatsappNumberurl ="+923264331067";
const Myaddress ="Pakistan, Punjab, Lahore";
const MyEmail ="codesperix@gmail.com";
// --------------------------
const about_page_data ={
  main_heading:{t1:"About",t2:"us"},
  bar:{w:"66.5%",h:"0.6rem"},
  main_heading_sub_headline:"Welcome to the heart of our success – our exceptional team. Passionate professionals driving innovation and delivering remarkable solutions for your business growth.",

  
  heading:()=><>Empowering Dreams:<br/>Our Journey of Excellence</>,
  about_us:()=><><p>Welcome to <span className="AgencyName">{AgencyName}</span>, where we excel in web development, designing, and digital marketing services. Our passionate team is dedicated to fueling your brand's online success.</p>
  <h3 className="heading about_subheadings">Our Story:</h3>
  <p>

Driven by innovation and expertise, we're committed to delivering exceptional solutions that elevate your online presence.
  </p>
  <h3 className="heading about_subheadings"> Why Work With Us:</h3> 
  <p>

Expect transparent communication, timely delivery, and ongoing support as we help your brand thrive online.
  </p>
<br/>
<p>

Partner with us for seamless web solutions and result-driven digital marketing strategies. Experience the power of a thriving online presence. Get in touch today.
</p>
                 </>
}
// --------------------------
const contact_page_data ={
  main_heading:{t1:"Get",t2:"Connected"},
  bar:{w:"23%",h:"0.6rem"},
  main_heading_sub_headline:"Unleash Your Brand's Full Potential and Let's Shape Your Digital Success Together. We're Eagerly Waiting to Connect with You and Discuss Your Project!"  
  
}
// --------------------------
const privacy_page_data ={
  main_heading:{t1:"Privacy",t2:"policy"},
  bar:{w:"54%",h:"0.6rem"},
  main_heading_sub_headline:"Our Commitment to Secure and Confidential Handling of Your Information. Your Trust, Our Priority.",
  detial_rules:(function(){
    return<>
    <p>At <span className="AgencyName">{AgencyName}</span>, we are committed to safeguarding your privacy and ensuring the security of your personal information. This Privacy Policy outlines how we collect, use, disclose, and protect the data we gather from our website visitors and clients. By using our services, you consent to the practices described herein.</p>

<h3 className="heading">
Data Collection and Usage:

</h3>
<p>
We may collect personal information such as names, email addresses, phone numbers, and company details when you interact with our website, subscribe to our newsletter, or engage with our services. This information is used to communicate with you, process your requests, and improve your overall experience with us.
</p>

<h3 className="heading">
Cookies and Tracking Technologies:
</h3>
<p>
To enhance your browsing experience, we use cookies and similar tracking technologies. These small files help us analyze website traffic, understand user preferences, and provide personalized content. You have the option to modify your browser settings to accept or reject cookies; however, certain features of our website may be affected if cookies are disabled.
</p>
<h3 className="heading">

Data Security:
</h3>
<p>

Protecting your data is of utmost importance to us. We implement robust security measures to prevent unauthorized access, disclosure, alteration, or destruction of your personal information. While we take all reasonable precautions, no method of data transmission over the internet is completely secure. Therefore, we cannot guarantee absolute security of your information.
</p>
<h3 className="heading">
Data Sharing:
</h3>
<p>
We may share your personal information with trusted third-party service providers who assist us in delivering our services. These third parties are obligated to maintain the confidentiality of your data and comply with applicable data protection laws.
</p>

<h3 className="heading">
Legal Requirements:
</h3>
<p>
In certain situations, we may be required to disclose your personal information to comply with legal obligations, protect our rights, or respond to lawful requests from public authorities.
</p>

<h3 className="heading">
Third-Party Links:
</h3 >
<p>
Our website may contain links to third-party websites or services. Please note that we are not responsible for the privacy practices or content of these third-party sites. We encourage you to review their respective privacy policies before engaging with them.
</p>

<h3 className="heading">
Changes to the Privacy Policy:
</h3>
<p>
We reserve the right to update this Privacy Policy periodically. Any changes will be posted on this page, and the date of the last update will be indicated at the top of the policy. By continuing to use our services, you agree to be bound by the updated Privacy Policy.

<br/>
For any privacy-related inquiries or to exercise your data rights, please contact our Data Protection Officer at <span className="AgencyName">{MyEmail}</span> . We are committed to addressing your concerns promptly and transparently.
<br/>
Thank you for trusting <span className="AgencyName">{AgencyName}</span> with your personal information. Your privacy and security are paramount to us, and we are dedicated to providing you with an exceptional experience while ensuring the utmost confidentiality and protection of your data.
</p>
    </>
  }  )()
  
}
// --------------------------
const RemotePolicy_page_data ={
  main_heading:{t1:"Remote",t2:"policy"},
  bar:{w:"52%",h:"0.6rem"},
  main_heading_sub_headline:"Our Commitment to Secure and Confidential Handling of Your Information. Your Trust, Our Priority.",
  detial_rules:(function(){
    return<>
    <p>At <span className="AgencyName">{AgencyName}</span>, we are committed to safeguarding your privacy and ensuring the security of your personal information. This Privacy Policy outlines how we collect, use, disclose, and protect the data we gather from our website visitors and clients. By using our services, you consent to the practices described herein.</p>
    <h3 class="heading">Introduction</h3>
    <p>At <span className="AgencyName">{AgencyName}</span>, we recognize the importance of flexibility and work-life balance for our employees. This Remote
        Workplace Policy outlines the guidelines and expectations for employees who work remotely.</p>

    <h3 class="heading">Eligibility</h3>
    <p>All <span className="AgencyName">{AgencyName}</span> employees are eligible to work remotely, subject to their role and job responsibilities. Remote
        work arrangements are approved on a case-by-case basis, considering factors such as job suitability,
        performance, and team collaboration requirements.</p>


    <h3 class="heading">Health and Safety</h3>
    <p>Employees are responsible for maintaining a safe and ergonomic remote workspace.
        <span className="AgencyName">{AgencyName}</span> is not liable for accidents, injuries, or health issues arising from remote workspaces.</p>

    <h3 class="heading">Expenses and Reimbursement</h3>
    <p>Reimbursement for reasonable and approved work-related expenses incurred while working remotely can be requested
        following the company's expense policy.</p>

    <h3 class="heading">Termination of Remote Work Arrangement</h3>
    <p><span className="AgencyName">{AgencyName}</span> reserves the right to terminate or modify a remote work arrangement at any time, based on business
        needs or performance considerations.</p>

    <h3 class="heading">Approval Process</h3>
    <p>Employees interested in working remotely should submit a formal request to their supervisor, outlining the
        reasons, proposed schedule, and any relevant details.
        Decisions regarding remote work arrangements will be communicated in writing by the employee's supervisor.</p>

    <h3 class="heading">Effective Date and Amendments</h3>
    <p>This Remote Workplace Policy is effective from <span className="AgencyName">July 1, 2023</span>.
        <span className="AgencyName">{AgencyName}</span> reserves the right to amend or modify this policy as needed, with appropriate notice to
        employees.</p>

    </>
  }  )()
  
}
// --------------------------
const services_page_data ={
  main_heading:{t1:"Our",t2:"Services"},
  bar:{w:"28%",h:"0.6rem"},
  main_heading_sub_headline:"Elevate your brand to new heights with our comprehensive web development, SEO, and UI/UX solutions. We optimize your online presence and deliver engaging user experiences for lasting impact.",
  services :[
    {
      title:"Web Development",
      detial:"Discover the power of expert web development services as our skilled developers bring your visions to life with captivating websites. With seamless functionality and the integration of cutting-edge technologies like React.js and Node.js, we offer tailored solutions to meet your specific needs. Elevate your brand, stand out in the digital realm, and unlock the full potential of your online presence with our exceptional web development services.",
      icon:"fas fa-laptop-code",
      id: "ServiceID"
  },
    {
          id: "ServiceID",
      title:"E-Commerce Websites",
      detial:"Unlock the full potential of your online business with our expertly crafted E-commerce websites. Our skilled team excels in creating captivating online stores with user-friendly interfaces, seamless functionality, and secure payment gateways. From eye-catching product showcases to smooth and secure checkout processes, we tailor custom solutions that drive sales and elevate your brand's online presence. Partner with us to deliver an exceptional E-commerce website that maximizes your online success and leaves a lasting impression on your customers.",
      icon:"fas fa-store",
      
  },
    {
          id: "ServiceID",
      title:"Wordpress Development",
      detial:"Experience the transformative power of WordPress Development with our dedicated team of experts. We specialize in creating stunning, custom websites with seamless user experiences. From crafting bespoke themes to implementing advanced SEO optimization techniques, our solutions are tailored to elevate your brand, attract more visitors, and ensure your online success. Partner with us for exceptional WordPress Development that sets your website apart and delivers a compelling online presence.",
      icon:"fab fa-wordpress-simple",
      
  },
    {
          id: "ServiceID",
      title:"Logo Designing",
      detial:"Discover the power of our professional Logo Designing service. Our skilled team crafts unique and captivating logos that represent your brand's essence. From concept to final design, we tailor each logo to match your vision and brand values. Elevate your online presence with logos that leave a lasting impression on your audience. Partner with us to enhance your brand identity and stand out from the competition.",
      icon:"fas fa-palette",
      
  },
    {
          id: "ServiceID",
      title:"UI/UX Designing",
      detial:"Immerse your audience in captivating digital experiences with our top-notch UI/UX Designing service. Our expert team combines aesthetics and functionality to craft visually appealing and user-friendly designs for websites and apps. From wireframes to interactive prototypes, we ensure seamless user interactions that leave a lasting impact. Partner with us to optimize your online presence and delight your users with SEO optimized UI/UX Designing that sets your brand apart in the competitive digital landscape.",
      icon:"fas fa-paint-brush",
      
  },
    {
          id: "ServiceID",
      title:"Digital Marketing",
      detial:"Maximize your online presence with our expert Digital Marketing service, including SEO optimization. We craft data-driven strategies to boost visibility, drive organic traffic, and enhance conversions. From on-page SEO to content marketing and social media campaigns, we tailor holistic approaches for success. Partner with us to stay ahead in the digital realm and reach your target audience effectively. Experience the impact of SEO optimized Digital Marketing that sets you apart and fuels your online success.",
      icon:"fas fa-search",
      
  },
  ]

  
 
}
// --------------------------
// -------------------------   
const home_page_data = {
  faqs:[
    {
      query:"How much does website development cost?",
      ans:"The cost of website development varies depending on several factors, including the complexity of the website, the number of pages, desired features and functionalities, the technology stack used.",
      active:false,
      id:get_new_id()  
  
    },
    {
      query:"How long does a Web Design Company take for Designing a website?",
      ans:(function(){return<>
      Different website requires a different length of time to get prepared for launch. But approximately it takes around 1-2 working days to design a single page of the website in Figma. <span className="AgencyName">{AgencyName}</span>, the top Web Design Development Company is focused on giving you quick service.</>})(),
      active:false,
      id:get_new_id()  
  
    },
    {
      query:"Do you create Responsive Web Designs?",
      ans:"As the leading Web Design and Web Development Company, we create responsive layouts. Your website and its contents would be visible and accessible on all gadget screens. As the leading Web Design Development Company, we take care of all these.",
      active:false,
      id:get_new_id()  
  
    },
    {
      query:"Do you provide SEO-friendly websites?",
      ans:"Of course, we provide SEO-friendly websites which appear in searches at one click in the Search Engines. A website has no use if it is not SEO-friendly. Therefore, one of our foremost aims is to incorporate SEO-friendliness into the websites we make for you.",
      active:false,
      id:get_new_id()  
  
    },
    {
      query:"What is the difference between front-end and back-end development?",
      ans:"Front-end development involves creating the visual elements of a website that users interact with directly. Back-end development handles server-side operations, database management, and other functionalities that users don't see but are crucial for the website's functionality.",
      active:false,
      id:get_new_id()  
  
    },
    {
      query:" Do I need a Content Management System (CMS) for my website?",
      ans:"A CMS, like WordPress or Joomla, makes it easier to manage and update website content. It depends on your needs and technical expertise. A CMS is beneficial for frequently updated websites or non-technical users.",
      active:false,
      id:get_new_id()  
  
    },
    
    {
      query:"What are wireframes and mockups in web design?",
      ans:"Wireframes are basic, low-fidelity layouts that outline the structure and elements of a webpage. Mockups are high-fidelity visual representations that give a clearer idea of the final design, including colors, images, and branding.",
      active:false,
      id:get_new_id()  
  
    },
    {
      query:" How can digital marketing help my business?",
      ans:"Digital marketing can increase brand awareness, drive website traffic, generate leads, boost sales, and provide valuable insights into customer behavior and preferences.",
      active:false,
      id:get_new_id()  
  
    },
 

 
  ],
  strategy:[
    {
      title:"Gather Requirements"
    },
    {
      title:"Analyze Requirements"
    },
    {
      title:"Determine Price & Milestones"
    },
    {
      title:"Milestone Completion & Payment"
    },
    {
      title:"Present for Review"
    },
    {
      title:"Finalize Project"
    }
  ],
  header:{
    intro_phrase:()=><>Welcome to <span className="AgencyName">{AgencyName}</span>,  We provide comprehensive web and mobile app solutions for a strong online presence. Our services include expert web development, mobile app development, strategic SEO for better visibility, and captivating UI/UX designs. Let's create a remarkable online journey for your audience and achieve digital success together.</>,
    services:services_page_data.services.map((e)=>e.title)
},
main_heading_phrases:{
  our_services:"Optimize Your Brand with Our Web Development, SEO, and UI/UX Solutions",
  faqs:"Browse Through and Find Solutions to Frequently Asked Questions",
  industries:"Enhancing Businesses in Hospitality, E-commerce, Automobile, Fashion, Food, Technology, Travel, and Diverse Sectors",
  work_flow:"A Look into Our Work Flow: From Start to Finish",

},
industries:[
  {
    icon:"fas fa-heartbeat",
    title:"Health-Care"
  },
  {
    icon:"fas fa-truck",
    title:"Logistic"
  },
  {
    icon:"fas fa-hands-helping",
    title:"hospitality"
  },
  {
    icon:"fas fa-home",
    title:"Real estate"
  },
  {
    icon:"fas fa-book",
    title:"educational"
  },
  {
    icon:"fas fa-shopping-cart",
    title:"E-Commerce"
  },
  {
    icon:"fas fa-shopping-bag",
    title:"Fashion"
  },
  {
    icon:"fas fa-car",
    title:"Automobile"
  }

],
services:services_page_data.services

}
// --------------------------

//---------------------------------
const notifi_Theme1={position: "bottom-left",
autoClose: 5000,
hideProgressBar: false,
closeOnClick: true,
pauseOnHover: true,
draggable: true,
progress: undefined,
theme: "dark"}
//---------------------------------
const website_routes ={
  contact_page:"/Contact",
  
  services_page:"/Services",
  about_page:"/About",
  home_page:"/Home",
  privacy_policy_page:"/privacy-policy",
  term_and_conditions_page:"/terms-and-conditions",
  RemotePolicy_page:"/Remote-Policy",

}

//---------------------------------
const Email_Api_Address="https://node_mailer-1-d9714405.deta.app/send_mail";
//---------------------------------
//---------------------------------
const NavBar_menu =[
  {
  url:website_routes.home_page,title:"Home"
 },
  {
  url:website_routes.services_page,title:"Services"
 },
 {
  url:website_routes.about_page,title:"About"
 },
 {
  url:website_routes.contact_page,title:"Contact"
 },
]
//---------------------------------
// --------------------------

// -------------------------
const footer_data={
  footerIconLinks :[
    { icon:"fab fa-linkedin-in",url:"https://www.linkedin.com/company/code-sperix-web-development/" },
    { icon:"fab fa-facebook-f",url:"https://www.facebook.com/profile.php?id=100095291447381" },
    // { icon:"fab fa-twitter",url:"/#" },
    { icon:"fab fa-google-plus-g",url:`mailto:${MyEmail}` }
        ],
    footer_important_links : NavBar_menu,
    footer_principles_pages_links : [
      { title:"Privacy Policy",url:website_routes.privacy_policy_page },
      { title:"Remote Policy",url:website_routes.RemotePolicy_page },
      // { title:"Terms & Condition",url:"term-and-conditions" }
    ],
    footer_heading_titles : [
      { t1:"Important", t2:"Links"},
      { t1:"agency", t2:"principles"}
    ],
    footer_description:()=><>
    Innovation meets impeccable design at <span className="AgencyName">{AgencyName}</span>. We passionately transform visions into seamless web experiences, empowering your business to thrive in the digital world.</>
}
export{
  home_page_data,
  Email_Api_Address,
    about_page_data,
    services_page_data,
    whatsappNumber,
    whatsappNumberurl,
    NavBar_menu,
   
    footer_data,
    notifi_Theme1,
    AgencyName,
    agency_name,
    initial_service_details,
    MyEmail,
    Myaddress,
contact_page_data,
 website_routes,
 privacy_page_data,RemotePolicy_page_data

}